/**
 * Dashboard Translations Module (Portuguese)
 * Matches English structure exactly
 * @module dashboard
 * @language pt
 */

export const dashboard = {
  index: {
    heroTitle: "Observatório de Futuros da Juventude dos Conselhos de Desenvolvimento JCI",
    heroSubtitle: "Medindo Liderança Jovem, Saúde Mental e Oportunidade Econômica Globalmente",
    heroDescription: "Uma plataforma orientada por dados analisando as condições para jovens líderes em 114 países. Usando métricas verificadas da rede global da JCI e parcerias de pesquisa.",
    globalImpactTitle: "Impacto Global em Resumo",
    verifiedData: "Dados verificados do Relatório de Impacto JCI 2025",
    globalMembers: "Membros Globais",
    activeWorldwide: "Ativos mundialmente",
    projects: "Projetos",
    period20242025: "Período: 2024-2025",
    volunteerHours: "Horas de Voluntariado",
    hoursContributed: "Horas contribuídas",
    countries: "Países",
    worldwidePresence: "Presença mundial",
    localOrganizations: "Organizações Locais",
    activeCommunities: "Comunidades ativas",
    digitalReachTitle: "Alcance e Pegada Digital",
    totalFollowers: "Seguidores Totais",
    jciccUsers: "Usuários jci.cc",
    memberDemographicsTitle: "Instantâneo de Demografia de Membros",
    averageAge: "Idade Média",
    yearsOld: "Anos",
    universityEducated: "Educação Universitária",
    bachelorsOrHigher: "Bacharelado ou superior",
    fullTime: "Tempo integral",
    entrepreneurs: "Empreendedores",
    employmentStatus: "Status de Emprego"
  },
  charts: {
    noDataAvailable: "Dados não disponíveis",
    dataLoadingSoon: "Os dados serão carregados em breve",
    noFunnelData: "Dados de funil não disponíveis",
    configureProcessData: "Configure os dados do processo",
    radarUnavailable: "Dados de radar não disponíveis",
    configurePerformanceIndicators: "Configure indicadores de desempenho",
    performanceUnavailable: "Dados de desempenho não disponíveis",
    configureTrendData: "Configure dados de tendência",
    currentProgress: "Progresso Atual",
    goal2040: "Meta 2040",
    mainValue: "Valor Principal",
    trend: "Tendência",
    goal: "Meta"
  },
  header: {
    title: "Observatório de Futuros dos Conselhos de Desenvolvimento JCI",
    subtitle: "Observatório Global dos Conselhos de Desenvolvimento",
    tagline: "Desenvolvendo Líderes para um Mundo em Mudança"
  },
  dashboard: {
    heroTitle: "Observatório de Futuros da Juventude dos Conselhos de Desenvolvimento JCI",
    heroSubtitle: "Medindo Liderança Jovem, Saúde Mental e Oportunidade Econômica",
    heroDescription: "Compreendendo a oportunidade global dos jovens através do Índice de Futuros da Juventude (YFI)",
    learnAboutFII: "Saiba mais sobre o YFI",
    globalReach: "Alcance Global",
    activeMembersWorldwide: "Membros Ativos Mundialmente",
    acrossCountries: "Em 114 Países",
    localOrganizations: "Organizações Locais",
    impactDelivered: "Impacto Entregue",
    beneficiariesReached: "Beneficiários Alcançados (2024-2025)",
    projectsImplemented: "Projetos Implementados",
    volunteerHours: "Horas de Voluntariado Contribuídas",
    digitalPresence: "Presença Digital",
    socialFollowers: "Seguidores nas Redes Sociais",
    monthlyImpressions: "Impressões Mensais",
    magazineReaders: "Leitores da Revista (70+ países)",
    websiteEngagement: "Engajamento no Site",
    activeUsers: "Usuários Ativos em jci.cc",
    pageViews: "Visualizações de Página",
    avgSessionDuration: "Duração Média da Sessão",
    whatIsFII: "O que é o Índice de Futuros da Juventude (YFI)?",
    fiiDescription: "O YFI mede a oportunidade dos jovens em 114 países usando três dimensões ponderadas",
    mentalHealth: "Saúde Mental",
    mentalHealthDesc: "Prevalência de saúde mental, taxas de suicídio, acesso a serviços",
    workforcePreparation: "Preparação da Força de Trabalho",
    workforceDesc: "Desemprego juvenil, desenvolvimento de habilidades, conquista educacional",
    entrepreneurship: "Empreendedorismo",
    entrepreneurshipDesc: "Ambiente de negócios, apoio ao empreendedorismo, inovação",
    exploreFullIndex: "Explorar o Índice Completo",
    memberExperience: "Instantâneo da Experiência do Membro",
    basedOnSurvey: "Baseado na Pesquisa de Membros (2025)",
    keyDemographics: "Demografia Chave",
    averageAge: "Idade Média",
    years: "anos",
    genderDistribution: "Distribuição de Gênero",
    male: "Masculino",
    female: "Feminino",
    other: "Outro",
    employmentStatus: "Status de Emprego",
    fullTimeEmployed: "Empregado em Tempo Integral",
    entrepreneurSelfEmployed: "Empreendedor/Autônomo",
    student: "Estudante",
    education: "Educação",
    universityDegrees: "Diplomas Universitários",
    regionalAgeRange: "Faixa Etária Regional",
    youngest: "Mais Jovem",
    oldest: "Mais Velho",
    membershipTenure: "Tempo de Membro",
    newMembersJoining: "Novos membros ingressando",
    buildingFoundation: "Construindo base",
    growingLeadership: "Crescendo liderança",
    experiencedMembers: "Membros experientes",
    sustainedCommitment: "Compromisso sustentado",
    projectsAcrossRegions: "projetos em 4 regiões",
    demographicsMotivations: "Demografia e motivações",
    mentalHealthIndex: "Índice de Saúde Mental",
    fiiWeight: "do YFI • Dados globais de crise",
    fiiRankingsAnalysis: "Índice e análise do YFI",
    digitalReach: "Tendências digitais e inovação",
    howFIICalculated: "Como o YFI é calculado",
    conferencesPrograms: "Conferências e programas da JCI",
    strategicGrowthTargets: "Metas estratégicas de crescimento",
    regionalCouncils: "AMDEC, ADC, APDC, EDC",
    howToContribute: "Como contribuir",
    frequentlyAskedQuestions: "Perguntas frequentes"
  },
  metrics: {
    membersActive: "Membros Ativos",
    countriesPresent: "Países Presentes",
    startupsSupported: "Startups Apoiadas",
    sustainableProjects: "Projetos Sustentáveis",
    completed: "concluído",
    countries: "Países",
    members: "Membros",
    projects: "Projetos",
    projectsPerYear: "Projetos/ano",
    memberDensity: "Densidade de Membros",
    country: "País",
    regionalDistribution: "Distribuição Regional",
    globalPresence: "Presença global da JCI em 2025",
    activeMembers: "Membros Ativos",
    globally: "globalmente",
    worldwidePresence: "presença mundial",
    communities: "Comunidades",
    activeCommunities: "comunidades ativas",
    yearsOfHistory: "Anos de História",
    since1915: "desde 1915",
    vs2024: "vs 2024",
    annualProjects: "Projetos Anuais",
    in2025: "em 2025"
  },
  dashboardTenure: {
    lessThan1Year: "<1 ano",
    years1to3: "1-3 anos",
    years4to6: "4-6 anos",
    years7to9: "7-9 anos",
    moreThan10Years: ">10 anos",
    respondents: "respondentes"
  },
  homeGlobalPresence: {
    title: "Presença Global JCI",
    subtitle: "Ativo em 114 Países em 4 Regiões",
    regions: "Regiões",
    countries: "Países",
    members: "Membros",
    localOrgs: "Orgs Locais"
  },
  globalPresenceMap: {
    title: "Presença Global JCI",
    subtitle: "Ativo em 114 Países em 4 Regiões",
    countriesLabel: "países",
    regionsLabel: "regiões",
    countriesCount: "Países",
    membersCount: "Membros",
    localOrgs: "Organizações Locais",
    regions: {
      asiaPacific: "Ásia e o Pacífico",
      europe: "Europa",
      africaMe: "África e Oriente Médio",
      americas: "América"
    }
  },
  observatoryHeader: {
    title: "Observatório de Futuros JCI",
    subtitle: "Observatório Global dos Conselhos de Desenvolvimento",
    tagline: "Desenvolvendo Líderes para um Mundo em Mudança",
    members: "Membros",
    countries: "Países",
    beneficiaries: "Beneficiários",
    projects: "Projetos"
  },
  homeGlobalMap: {
    title: "Presença Global JCI",
    subtitle: "Jovens líderes ativos em 114 países",
    members: "Membros",
    countries: "Países",
    localOrgs: "Orgs Locais",
    click: "Clique para detalhes"
  },
  jciGlobalPresence: {
    title: "Presença Global JCI",
    subtitle: "Ativo em 114 Países em 4 Regiões",
    countries: "países",
    orgs: "orgs",
    regions: "regiões",
    africaMiddleEast: "África e Oriente Médio",
    americas: "América",
    asiaPacific: "Ásia e o Pacífico",
    europe: "Europa"
  },
  chartsAdvanced: {
    loading: "Carregando gráfico...",
    noData: "Dados não disponíveis",
    error: "Falha ao carregar gráfico",
    xAxis: "Eixo X",
    yAxis: "Eixo Y",
    legend: "Legenda",
    tooltip: "Dica",
    zoom: "Zoom",
    pan: "Mover",
    reset: "Redefinir",
    download: "Baixar"
  },
  digitalEcosystem: {
    title: "Ecossistema Digital JCI",
    subtitle: "Plataformas digitais impulsionando engajamento e alcance dos membros",
    website: "Website",
    socialMedia: "Redes Sociais",
    magazine: "Revista",
    activeUsers: "Usuários Ativos",
    followers: "Seguidores",
    readers: "Leitores",
    engagement: "Engajamento",
    reach: "Alcance",
    impressions: "Impressões"
  },
  observatoryMastery: {
    title: "Maestria do Observatório",
    modulesExplored: "Módulos Explorados",
    outOf: "de",
    observer: "Observador",
    analyst: "Analista",
    visionary: "Visionário",
    keepExploring: "Continue explorando para desbloquear insights!",
    almostThere: "Quase lá! Você está se tornando um especialista.",
    masterAchieved: "Você dominou o Observatório!",
    unlockReward: "Visite todos os módulos para desbloquear o Resumo Executivo",
    loginToTrack: "Faça login para acompanhar seu progresso de exploração em todos os 14 módulos",
    signInToStart: "Entrar para começar"
  },
  apiAnalytics: {
    title: "Análise de API",
    description: "Monitore uso, desempenho e tendências da API",
    last24Hours: "Últimas 24 Horas",
    last7Days: "Últimos 7 Dias",
    last30Days: "Últimos 30 Dias",
    totalRequests: "Total de Requisições",
    successful: "bem-sucedidas",
    avgResponseTime: "Tempo Médio de Resposta",
    acrossAllEndpoints: "Em todos os endpoints",
    errorRate: "Taxa de Erro",
    errors: "erros",
    activeApiKeys: "Chaves de API Ativas",
    totalKeys: "chaves totais",
    requestsOverTime: "Requisições ao Longo do Tempo",
    requestsByDay: "Requisições de API por dia",
    requestsByEndpoint: "Requisições por Endpoint",
    distributionAcrossEndpoints: "Distribuição entre endpoints da API",
    responseStatusCodes: "Códigos de Status de Resposta",
    distributionOfStatusCodes: "Distribuição de códigos de status HTTP",
    topApiKeys: "Principais Chaves de API",
    keysWithHighestUsage: "Chaves com maior uso",
    active: "Ativa",
    inactive: "Inativa",
    noApiKeysFound: "Nenhuma chave de API encontrada"
  }
} as const;
